// extracted by mini-css-extract-plugin
export var label = "_j7-2";
export var slideContainer = "_j7-0";
export var slider = "_j7-1";